import { NotificationRootState } from '@shared/redux/state/notification';

export const initNotificationRootState: NotificationRootState = {};
